/* BOX IMPORT — Carrito mixto (snippets/bi-carrito-mixto.liquid): quitar todos los productos de un tipo y frenar el pago
   si el carrito mezcla Pagá en la Puerta con Envío Inmediato. Se carga en todas las páginas desde layout/theme.liquid. */
(() => {
    if (window.__biMixto) return;
    window.__biMixto = true;
    const caja = () => [...document.querySelectorAll('[data-bi-mixto]')].find((c) => c.offsetParent !== null);

    // Quitar todos los productos de un tipo, sin recargar la página
    document.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-bi-quitar]');
      if (!b || b.disabled) return;
      const claves = b.dataset.biQuitar.split(',').filter(Boolean);
      if (!claves.length) return;
      b.disabled = true;
      b.textContent = 'Quitando…';
      const ok = window.biActualizarCarrito ? await window.biActualizarCarrito(Object.fromEntries(claves.map((k) => [k, 0]))) : false;
      if (!ok) {
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: Object.fromEntries(claves.map((k) => [k, 0])) }) }).catch(() => {});
        window.location.href = '/cart';
      }
    });

    // Con productos de los dos tipos no se puede ir a pagar: el cartel avisa qué hacer
    window.addEventListener('click', (e) => {
      const boton = e.target instanceof Element && e.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]');
      if (!boton) return;
      const c = caja();
      if (!c) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      c.scrollIntoView({ behavior: 'smooth', block: 'start' });
      c.removeAttribute('data-sacudir');
      void c.offsetWidth;
      c.setAttribute('data-sacudir', '');
    }, true);
  })();
